import { api } from "../services/index";

export function getUsers() {
  return api.get(`/users`);
}

export function addUser(data, dryRun = false) {
  return api.post(`/users${dryRun ? "?dryRun=true" : ""}`, data);
}

export function getUser(userID) {
  return api.get(`/users/${userID}`);
}

export function getUserPolicies(userID) {
  return api.get(`/users/${userID}/policies`);
}

export function editUser(userID, data) {
  return api.patch(`/users/${userID}`, data);
}

export function deleteUser(userID) {
  return api.delete(`/users/${userID}`);
}

export function getUserGroups(userID) {
  return api.get(`/users/${userID}/groups`);
}

export function getUserRoles(userID) {
  return api.get(`/users/${userID}/roles`);
}

export function getUserApps(userID) {
  return api.get(`/users/${userID}/apps`);
}

export function getUserTokens(userID) {
  return api.get(`/users/${userID}/token`);
}

export function me() {
  return api.get("/me");
}

export function generateToken(userID, data) {
  return api.post(`/users/${userID}/token`, data);
}

export function deleteToken(userID, tokenID) {
  return api.delete(`/users/${userID}/token/${tokenID}`);
}
export function getGroups() {
  return api.get(`/groups`);
}

export function resetPassword(userID) {
  return api.post(`/users/${userID}/reset-password`);
}
